import { render, staticRenderFns } from "./appendix-link-card.vue?vue&type=template&id=04e7804e&scoped=true"
import script from "./appendix-link-card.vue?vue&type=script&lang=js"
export * from "./appendix-link-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e7804e",
  null
  
)

export default component.exports